var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66675C14.6025 1.66675 18.3334 5.39842 18.3334 10.0001C18.3334 14.6017 14.6025 18.3334 10 18.3334C5.39752 18.3334 1.66669 14.6017 1.66669 10.0001C1.66669 5.39842 5.39752 1.66675 10 1.66675ZM10 3.05591C6.17085 3.05591 3.05585 6.17092 3.05585 10.0001C3.05585 13.8292 6.17085 16.9442 10 16.9442C13.8292 16.9442 16.9442 13.8292 16.9442 10.0001C16.9442 6.17092 13.8292 3.05591 10 3.05591ZM9.37502 5.00008C9.69127 5.00008 9.9529 5.23536 9.99431 5.54031L10 5.62508V10.0001H12.7084C13.0534 10.0001 13.3334 10.2801 13.3334 10.6251C13.3334 10.9413 13.0981 11.203 12.7931 11.2444L12.7084 11.2501H9.37502C9.05877 11.2501 8.79714 11.0148 8.75573 10.7099L8.75002 10.6251V5.62508C8.75002 5.28008 9.03002 5.00008 9.37502 5.00008Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.c846b0067537202cad94a3cc2cb4dfc2.svg";
export { ForwardRef as ReactComponent };